import { render } from "./AllMasterLogoHeli.vue?vue&type=template&id=28b4840c"
const script = {}

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__